export function extrairConceitosUnicos(itens) {
    const conceitosSet = new Set();

    itens.forEach(item => {
        if (item.conceitos) {
            const conceitosArray = item.conceitos.split(',').map(conceito => conceito.trim().toLowerCase());
            conceitosArray.forEach(conceito => conceitosSet.add(conceito));
        }
    });

    return Array.from(conceitosSet);
}